
import React from 'react';
import { Company } from '@/lib/types';
import { ConfirmDialog } from "@/components/ui/confirm";
import { UserManagementCard } from './UserManagementCard';

interface UserManagementProps {
  companies: Company[];
}

export const UserManagement: React.FC<UserManagementProps> = ({ companies }) => {
  return (
    <>
      <ConfirmDialog />
      <UserManagementCard companies={companies} />
    </>
  );
};
